import {useAuth} from "contexts";
import axios, {AxiosInstance, InternalAxiosRequestConfig} from "axios";
import {PropsWithChildren, useEffect, useRef, useState} from "react";
import {flexBaseUrl, springBaseUrl} from "../constants/defaultValues";
import {addRequestIdToQuery, setAuthTokenInHeader} from "@bounce/shared/requests";

export const axiosSpringInstance = axios.create({
  baseURL: springBaseUrl,
});

export const axiosFlexInstance = axios.create({
  baseURL: flexBaseUrl,
});

const addSsoAuthFallbackInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (!config.headers.Authorization) {
      const agentToken = localStorage.getItem("agentToken");
      if (agentToken) {
        config.headers.Authorization = `Bearer ${agentToken}`;
      }
    }
    return config;
  });
};

addSsoAuthFallbackInterceptor(axiosFlexInstance);
addSsoAuthFallbackInterceptor(axiosSpringInstance);

const BackofficeApiManager = ({children}: PropsWithChildren) => {
  const {token} = useAuth();
  const isInitialized = useRef(false);
  const [axiosReady, setAxiosReady] = useState(false);
  const instances = [axiosFlexInstance, axiosSpringInstance];

  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    [axiosFlexInstance, axiosSpringInstance].forEach((instance) => addRequestIdToQuery(instance));

    setAxiosReady(true);
  }, []);

  useEffect(() => {
    if (axiosReady) {
      setAuthTokenInHeader(token, instances);
    }
  }, [token, axiosReady]);

  if (!axiosReady) return null;

  return <>{children}</>;
};

export default BackofficeApiManager;
